function addTrailingNewLine(state, config) {
  if ((!state || state.endsWith("\n")) && !(config == null ? void 0 : config.force)) {
    return state;
  } else {
    return state + "\n";
  }
}
export {
  addTrailingNewLine
};
//# sourceMappingURL=addTrailingNewLine.js.map
